// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"6d4636cb","233":"4b202cad","369":"681de4da","777":"d85915b3","936":"c448936c"}[chunkId] + ".js";
};